// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBox_checkbox__olzti","circle":"CheckBox_circle__t3Jus"};